var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',{attrs:{"breadcrumbs":_vm.breadcrumbs}},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section--listing-form"},[_c('client-only',[(_vm.draftAccessReady)?_c('listing-form',{ref:"listingForm",attrs:{"formProp":"add"}}):_vm._e()],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }